export default __webpack_public_path__ + "static/media/Frame 1.fcacc633.svg";